import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import CourseLandingView from "@/components/shared/CourseLandingView";
import { courseGet } from "@/admin/adminApi";

export default function CoursePreview() {
  const { id } = useParams();
  const [course, setCourse] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    courseGet(id).then(setCourse).catch(() => setErr(true));
  }, [id]);

  if (err)
    return (
      <div className="flex min-h-screen flex-col items-center justify-center gap-3 text-center">
        <p className="text-slate-600">Course not found or you are not signed in as admin.</p>
        <a href="/admin/courses" className="text-orange underline">Back to Course Management</a>
      </div>
    );
  if (!course)
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Loader2 className="h-6 w-6 animate-spin text-orange" />
      </div>
    );

  return (
    <div data-testid="course-preview">
      <div className="sticky top-0 z-[100] bg-amber-500 py-2 text-center text-sm font-semibold text-white">
        DRAFT PREVIEW — status: {course.status} · not visible to the public until published
      </div>
      <CourseLandingView course={course} />
    </div>
  );
}
